// extracted by mini-css-extract-plugin
export default {"homePageSlideContainer":"HomePageSlides_homePageSlideContainer__3sPWk"};